import { render } from "./StepGeneracionCertificado.vue?vue&type=template&id=3b6dcc63&scoped=true"
import script from "./StepGeneracionCertificado.vue?vue&type=script&lang=js"
export * from "./StepGeneracionCertificado.vue?vue&type=script&lang=js"

import "./StepGeneracionCertificado.vue?vue&type=style&index=0&id=3b6dcc63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6dcc63"]])

export default __exports__